import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../components/layout';
import { HiOutlineDocument } from 'react-icons/hi2';

import './NotFound.styles.css';

export default function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="not-found-page">
        <div className="not-found-container">
          <div className="not-found-image">
            <HiOutlineDocument fontSize={96} color="var(--primary-color)" />
          </div>
          <div className="not-found-alert">{t('common.not-found-default')}</div>
          <div className="not-found-description">{t('common.not-found-default-hint')}</div>
          <div className="not-found-actions">
            <span onClick={() => navigate(-1)}>{t('common.back')}</span>
            <span onClick={() => navigate('/')}>{t('common.portal')}</span>
          </div>
        </div>
      </div>
    </Layout>
  );
}
